// extracted by mini-css-extract-plugin
export default {"container":"styles_container__eW1Jv","logo":"styles_logo__A1thy","text":"styles_text__o1tmV","_404_img":"styles__404_img__thzbL","link":"styles_link__48l66"};